import React, { useState } from "react";
import { Rating } from "react-simple-star-rating";
import useLocalStorage from "../../Hooks/useLocalStorage";

import axios from "axios";

export default function FinFormation() {
	const [rating, setRating] = useState(0);
	const [rating2, setRating2] = useState(0);
	const [rating3, setRating3] = useState(0);
	const [rating4, setRating4] = useState(0);
	const [rating5, setRating5] = useState(0);

	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const userID = urlParams.get("id");
	const userName = urlParams.get("name");
	const formation = urlParams.get("formation");

	const [comment, setComment] = useState("");
	const [suggestion, setSuggestion] = useState("");
	const [methodes, setMethodes] = useState("");
	const [rappel, setRappel] = useState("");

	const [sent, setSent] = useLocalStorage("completed", false);

	var tooltipArr = ["1 sur 5", "2 sur 5", "3 sur 5", "4 sur 5", "5 sur 5"];

	const sendForm = async e => {
		e.preventDefault();

		var avis1;
		var avis2;
		var avis3;
		var avis4;
		var avis5;

		if (rating === 20) {
			avis1 = "1 sur 5";
		}
		if (rating === 40) {
			avis1 = "2 sur 5";
		}
		if (rating === 60) {
			avis1 = "3 sur 5";
		}
		if (rating === 80) {
			avis1 = "4 sur 5";
		}
		if (rating === 100) {
			avis1 = "5 sur 5";
		}

		if (rating2 === 20) {
			avis2 = "1 sur 5";
		}
		if (rating2 === 40) {
			avis2 = "2 sur 5";
		}
		if (rating2 === 60) {
			avis2 = "3 sur 5";
		}
		if (rating2 === 80) {
			avis2 = "4 sur 5";
		}
		if (rating2 === 100) {
			avis2 = "5 sur 5";
		}

		if (rating3 === 20) {
			avis3 = "1 sur 5";
		}
		if (rating3 === 40) {
			avis3 = "2 sur 5";
		}
		if (rating3 === 60) {
			avis3 = "3 sur 5";
		}
		if (rating3 === 80) {
			avis3 = "4 sur 5";
		}
		if (rating3 === 100) {
			avis3 = "5 sur 5";
		}

		if (rating4 === 20) {
			avis4 = "1 sur 5";
		}
		if (rating4 === 40) {
			avis4 = "2 sur 5";
		}
		if (rating4 === 60) {
			avis4 = "3 sur 5";
		}
		if (rating4 === 80) {
			avis4 = "4 sur 5";
		}
		if (rating4 === 100) {
			avis4 = "5 sur 5";
		}

		if (rating5 === 20) {
			avis5 = "1 sur 5";
		}
		if (rating5 === 40) {
			avis5 = "2 sur 5";
		}
		if (rating5 === 60) {
			avis5 = "3 sur 5";
		}
		if (rating5 === 80) {
			avis5 = "4 sur 5";
		}
		if (rating5 === 100) {
			avis5 = "5 sur 5";
		}

		try {
			axios.post("https://global-academie.herokuapp.com/avis/formation", {
				userID,
				userName,
				formation,
				niveauInitial: avis1,
				niveauFinal: avis2,
				maitrise: avis3,
				competences: avis4,
				motivation: avis5,
				rappel,
				methodes,
				comment,
				suggestion,
			});
			setSent(true);
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<div className="flex min-h-screen w-full flex-col items-center justify-center">
			<form
				onSubmit={sendForm}
				className="my-16 flex w-full flex-col items-center justify-center px-4 md:w-1/2 md:px-0"
			>
				<h2 className="flex w-full items-center justify-between text-3xl font-bold text-indigo-500">
					Bilan de fin formation
				</h2>
				<hr className="my-4 h-[3px] w-[100px] self-start border-none bg-indigo-200" />
				<div
					className={
						sent
							? "hidden"
							: "flex w-full flex-col items-center justify-center space-y-7"
					}
				>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor="rappelObjectif"
						>
							Rappel des objectifs
						</label>
						<textarea
							value={rappel}
							onChange={e => setRappel(e.target.value)}
							name="rappelObjectif"
							id="rappelObjectif"
							placeholder="Rappel des objectifs"
							className="mt-1 max-h-[250px] min-h-[130px] w-full rounded-md border border-gray-400/50 bg-white p-3 shadow-md outline-none dark:bg-gray-700 dark:text-white"
						/>
					</div>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor=""
						>
							Niveau initial
						</label>
						<div className="mt-3 flex items-center">
							<Rating
								showTooltip={true}
								transition={true}
								tooltipArray={tooltipArr}
								tooltipDefaultText="Votre réponse"
								onClick={rate => setRating(rate)}
								ratingValue={rating}
								fillColorArray={[
									"#f17a45",
									"#f19745",
									"#f1a545",
									"#f1b345",
									"#f1d045",
								]}
							/>
						</div>
					</div>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor=""
						>
							Niveau final
						</label>
						<div className="mt-3 flex items-center">
							<Rating
								showTooltip={true}
								transition={true}
								tooltipArray={tooltipArr}
								tooltipDefaultText="Votre réponse"
								onClick={rate => setRating2(rate)}
								ratingValue={rating2}
								fillColorArray={[
									"#f17a45",
									"#f19745",
									"#f1a545",
									"#f1b345",
									"#f1d045",
								]}
							/>
						</div>
					</div>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor="moyenPedago"
						>
							Méthodes et moyens pédagogiques employés
						</label>
						<textarea
							value={methodes}
							onChange={e => setMethodes(e.target.value)}
							name="moyenPedago"
							id="moyenPedago"
							placeholder="Méthodes et moyens pédagogiques employés"
							className="mt-1 max-h-[250px] min-h-[150px] w-full rounded-md border border-gray-400/50 bg-white p-3 shadow-md outline-none dark:bg-gray-700 dark:text-white"
						/>
					</div>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor="Suggestion"
						>
							Suggestions et axes d’amélioration
						</label>
						<textarea
							value={suggestion}
							onChange={e => setSuggestion(e.target.value)}
							name="Suggestion"
							id="Suggestion"
							placeholder="Suggestions"
							className="mt-1 max-h-[250px] min-h-[150px] w-full rounded-md border border-gray-400/50 bg-white p-3 shadow-md outline-none dark:bg-gray-700 dark:text-white"
						/>
					</div>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor=""
						>
							Maitrise des outils de base
						</label>
						<div className="mt-3 flex items-center">
							<Rating
								showTooltip={true}
								transition={true}
								tooltipArray={tooltipArr}
								tooltipDefaultText="Votre réponse"
								onClick={rate => setRating3(rate)}
								ratingValue={rating3}
								fillColorArray={[
									"#f17a45",
									"#f19745",
									"#f1a545",
									"#f1b345",
									"#f1d045",
								]}
							/>
						</div>
					</div>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor=""
						>
							Associer les compétences acquise lors de la
							formation en pratique
						</label>
						<div className="mt-3 flex items-center">
							<Rating
								showTooltip={true}
								transition={true}
								tooltipArray={tooltipArr}
								tooltipDefaultText="Votre réponse"
								onClick={rate => setRating4(rate)}
								ratingValue={rating4}
								fillColorArray={[
									"#f17a45",
									"#f19745",
									"#f1a545",
									"#f1b345",
									"#f1d045",
								]}
							/>
						</div>
					</div>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor=""
						>
							Motivation et curiosité
						</label>
						<div className="mt-3 flex items-center">
							<Rating
								showTooltip={true}
								transition={true}
								tooltipArray={tooltipArr}
								tooltipDefaultText="Votre réponse"
								onClick={rate => setRating5(rate)}
								ratingValue={rating5}
								fillColorArray={[
									"#f17a45",
									"#f19745",
									"#f1a545",
									"#f1b345",
									"#f1d045",
								]}
							/>
						</div>
					</div>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor="moyenPedago"
						>
							Commentaire
						</label>
						<textarea
							value={comment}
							onChange={e => setComment(e.target.value)}
							name="moyenPedago"
							id="moyenPedago"
							placeholder="Méthodes et moyens pédagogiques employés"
							className="mt-1 max-h-[250px] min-h-[150px] w-full rounded-md border border-gray-400/50 bg-white p-3 shadow-md outline-none dark:bg-gray-700 dark:text-white"
						/>
					</div>
					<button
						type="submit"
						className="w-full rounded-md border-2 border-transparent bg-indigo-500 p-3 font-medium text-white transition-all duration-200 hover:border-indigo-500 hover:bg-transparent hover:text-indigo-500"
					>
						Envoyer
					</button>
				</div>
				<div
					className={
						sent
							? "visible-check flex h-[250px] flex-col items-center justify-center opacity-100 transition-all duration-300 ease-in-out"
							: "flex h-[0px] flex-col items-center justify-center overflow-hidden opacity-0 transition-all duration-300 ease-in-out"
					}
				>
					<svg
						className="checkmark"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 52 52"
					>
						<circle
							className="checkmark__circle"
							cx="26"
							cy="26"
							r="25"
							fill="none"
						/>
						<path
							className="checkmark__check"
							fill="none"
							d="M14.1 27.2l7.1 7.2 16.7-16.8"
						/>
					</svg>
					<h4 className="my-7 text-2xl font-medium">
						Merci pour vos réponses!
					</h4>
				</div>
			</form>
		</div>
	);
}
